import { useCallback } from "react";

const useQuizUpdater = (dispatch) => {
  const updateItem = useCallback(
    (index, newData) => {
      dispatch({
        type: "UPDATE_ITEM",
        payload: { index, newData },
      });
    },
    [dispatch]
  );

  const updateOptionField = useCallback(
    (index, optionKey, field, value) => {
      dispatch({
        type: "UPDATE_OPTION",
        index,
        optionKey,
        field,
        value,
      });
    },
    [dispatch]
  );

  return { updateItem, updateOptionField };
};

export default useQuizUpdater;
